/* eslint-disable deprecation/deprecation */
import { ExtendedConfig } from "./types";
import Browser from "./utils/browser";
import { cleanUp } from "./utils/cleanUp";

function print(config: ExtendedConfig, printFrame: HTMLIFrameElement) {
  const { frameId } = config;

  // Append iframe element to document body
  document.getElementsByTagName("body")[0].appendChild(printFrame);

  // Get iframe element
  const iframeElement = document.getElementById(frameId) as HTMLIFrameElement | null;

  if (!iframeElement) {
    return;
  }

  // Wait for iframe to load all content
  iframeElement.onload = () => {
    // Add a delay for Firefox. In my tests, 1000ms was sufficient but 100ms was not
    if (Browser.isFirefox || Browser.isSafari) {
      setTimeout(() => performPrint(iframeElement, config), 1000);
    } else {
      performPrint(iframeElement, config);
    }
  };
}

function performPrint(iframeElement: HTMLIFrameElement, config: ExtendedConfig) {
  const { onError } = config;

  try {
    // Probably allowing to make this work in Firefox without needing to focus the window again
    if (!Browser.isFirefox) {
      iframeElement.focus();
    }

    // If Edge or IE, try catch with execCommand
    if (Browser.isEdgeHTML || Browser.isIE || Browser.isSafari) {
      try {
        iframeElement.contentWindow?.document.execCommand("print", true);
      } catch {
        iframeElement.contentWindow?.print();
      }
    } else {
      // Other browsers
      iframeElement.contentWindow?.print();
    }
  } catch (error: any) {
    onError?.(error);
  } finally {
    if (Browser.isFirefox) {
      // Move the iframe element off-screen and make it invisible
      iframeElement.style.visibility = "hidden";
      iframeElement.style.left = "-1px";
    }
    setTimeout(() => cleanUp(config), 500);
  }
}

export { print };
